import { all } from 'redux-saga/effects'

import { dataSaga } from './data/saga'
import { mentorsSaga } from './mentors/sagas'
import { scheduleLinkSaga } from './schedule-link/sagas'

export function* mentorSaga() {
  yield all([dataSaga(), mentorsSaga(), scheduleLinkSaga()])
}
